import type { MenuSchemaEntry } from '@bucketplace/design-system/bds';
import { useQuery } from '@tanstack/react-query';
import { useTRPC } from '@/trpc/utils';
import { createO2OMenu } from './createO2OMenu';
import { composeStoreFeeds, createStoreMenu } from './createStoreMenu';
import { useCreateHnCMenu } from './useCreateHnCMenu';

const useCreateMenu = (
  navItems: unknown,
  pathname: string,
): MenuSchemaEntry[] => {
  const hncMenu = useCreateHnCMenu();

  const navigationMenuList = [
    ...hncMenu,
    ...createStoreMenu(),
    ...createO2OMenu(),
  ];

  const navigationData = navigationMenuList.map((data) => {
    // hooks over `/store/*`
    if (data.href != null && data.href.endsWith('/store')) {
      return {
        ...data,
        entries: composeStoreFeeds(navItems, pathname),
      };
    }
    return data;
  });

  return navigationData;
};

export const useNavigationMenu = (pathname: string) => {
  const trpc = useTRPC();
  const { data, error } = useQuery(trpc.navigation.queryOptions());

  const combined = useCreateMenu(data, pathname);

  return { error, data: combined };
};
